import type { GeoCoordinates } from "../../components/locationPopup/useGeoLocator";
import { useInitialMapCameraSettings } from "../../components/map/useInitialMapCameraSettings";
import { useGlobalState } from "../../state/hooks/useGlobalState";

export function useGeoCoordinatesForMultiModelRequests(): GeoCoordinates {
    const { selectedLocation } = useGlobalState();
    const { initialBounds, initialCenter } = useInitialMapCameraSettings();

    if (selectedLocation !== undefined) {
        return selectedLocation;
    } else {
        if (initialBounds !== undefined) {
            const [minLng, minLat, maxLng, maxLat] = initialBounds;

            return {
                lng: (minLng + maxLng) / 2,
                lat: (minLat + maxLat) / 2,
            };
        } else if (initialCenter !== undefined) {
            return {
                lng: initialCenter.lng,
                lat: initialCenter.lat,
            };
        } else {
            throw new Error(
                "Geo coordinates for multi model request could not be determined. This should normally not happen.",
            );
        }
    }
}
